module.exports = __webpack_public_path__ + "img/sun-with-clouds-snow.7f247fd9.png";